import {
  Alert,
  Collapse,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Radio,
  RadioGroup,
} from '@mui/material';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { useAppDispatch } from '../../../pages/assessment';
import { updateMeta } from '../../../redux/meta';
import { setIsGuardian as setIsGuardianSession } from '../../../redux/session';
import { AssessmentButtons, AssessmentCard } from '../shared';
import { rules } from './rules';

type FormValues = {
  // Not a boolean to prevent unintentional conversion to string
  isGuardian: 'isGuardian' | 'isNotGuardian';
};

const PatientType = () => {
  const dispatch = useAppDispatch();

  const {
    control,
    handleSubmit,
    formState: { isValid, isSubmitting },
    watch,
  } = useForm<FormValues>();

  const guardianStringToBoolean = (string: FormValues['isGuardian']) => {
    if (string === 'isGuardian') return true;
    if (string === 'isNotGuardian') return false;
  };

  const onSubmit: SubmitHandler<FormValues> = data => {
    dispatch(setIsGuardianSession(guardianStringToBoolean(data.isGuardian)));
    dispatch(updateMeta());
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <AssessmentCard>
        <Controller
          name="isGuardian"
          control={control}
          defaultValue={null}
          rules={rules.requiredCheckboxOrRadio as any}
          render={({ field, fieldState }) => (
            <FormControl error={!!fieldState.error}>
              <RadioGroup {...field}>
                <FormControlLabel
                  value="isNotGuardian"
                  control={<Radio />}
                  label="Myself"
                />
                <FormControlLabel
                  value="isGuardian"
                  control={<Radio />}
                  label="Someone else who’s under 18"
                />
              </RadioGroup>
              {fieldState.error && (
                <FormHelperText sx={{ ml: 0 }}>
                  {fieldState.error.message}
                </FormHelperText>
              )}
            </FormControl>
          )}
        />
        <Collapse in={watch('isGuardian') === 'isGuardian'}>
          <Alert severity="info" sx={{ mt: 1 }}>
            Please answer all medical related questions to the best of your
            knowledge on behalf of the patient.
          </Alert>
        </Collapse>
      </AssessmentCard>
      <AssessmentButtons
        primary={{
          type: 'submit',
          children: 'Tell us a little about you',
          disabled: !isValid || isSubmitting,
          loading: isSubmitting,
        }}
      />
    </form>
  );
};

export default PatientType;
